import {purchasingApi as api} from './api';
// Both catalog endpoints return bounded, stably sorted arrays.
export async function catalogRecords(path) {
 const rows=[];
 for(let offset=0;offset<10000;offset+=500){const page=await api(path+(offset?(path.includes('?')?'&':'?')+`offset=${offset}`:''));rows.push(...page);if(page.length<500)return rows;}
 throw new Error('El catálogo supera el límite de 10,000 registros; reduzca la unidad de negocio.');
}
